import Vue from 'vue'

export default {
  storeRecommendedTests (tests) {
    return Vue.http.post(window.API_URL + 'doctors/lab_test/create', tests, {
      progress (e) {
      }
    })
  },
  getPackages (customerId) {
    return Vue.http.get(window.API_URL + `doctors/packages/search/${customerId}`)
  }

}



// WEBPACK FOOTER //
// ./src/api/lab_tests.js